import {configureStore} from '@reduxjs/toolkit';
import RefreshReducer from './features/navigateSlice';
import fiscalYearReducer from './features/fiscalYearSlice';

export const store = configureStore({
    reducer: {
        fiscalYear: fiscalYearReducer,
        refresh: RefreshReducer
    }
})